// @flow
import { PUBLIC_URL } from './env';
export const IMG_REPOSITORY = PUBLIC_URL + 'images/repository.svg';
export const DEFAULT_AVATAR = PUBLIC_URL + 'images/user.svg';
export const COMMIT_TIMEOUT_MINUTES = 15;
